import React from "react";

import transferImg from '../assets/img/transfer.png';

const HeroComp = () => {

  return (
    <section id="home" className="hero">
      <div className="floating-icons">

        <div className="floating-icon">
          <svg width="80" height="80" viewBox="0 0 24 24">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        </div>

        <div className="floating-icon">
          <svg width="70" height="70" viewBox="0 0 24 24">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
        </div>

        <div className="floating-icon">
          <svg width="75" height="75" viewBox="0 0 24 24">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
        </div>

        <div className="floating-icon">
          <svg width="85" height="85" viewBox="0 0 24 24">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <circle cx="10" cy="15" r="3"></circle>
            <line x1="12.5" y1="17.5" x2="15" y2="20"></line>
          </svg>
        </div>

        <div className="floating-icon">
          <svg width="65" height="65" viewBox="0 0 24 24">
            <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
            <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
            <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
          </svg>
        </div>

        <div className="floating-icon">
          <svg width="72" height="72" viewBox="0 0 24 24">
            <path d="M2 12C2 6.5 6.5 2 12 2a10 10 0 0 1 8 4"></path>
            <path d="M5 19.5C5.5 18 6 15 6 12c0-.7.12-1.37.34-2"></path>
            <path d="M17.29 21.02c.12-.6.43-2.3.5-3.02"></path>
            <path d="M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4"></path>
            <path d="M8.65 22c.21-.66.45-1.32.57-2"></path>
            <path d="M14 13.12c0 2.38 0 6.38-1 8.88"></path>
            <path d="M2 16h.01"></path>
            <path d="M21.8 16c.2-2 .131-5.354 0-6"></path>
            <path d="M9 6.8a6 6 0 0 1 9 5.2c0 .47 0 1.17-.02 2"></path>
          </svg>
        </div>
      </div>
      <div className="container">
        <div className="hero-background">
          <div className="hero-content">
            <span className="hero-tag">Mobile Forensics Excellence</span>
            <h1>Precision Data Extraction & Forensic Analysis</h1>
            <p className="hero-description">
              True-Extract delivers industry-leading mobile forensics solutions, combining cutting-edge technology with expert analysis to extract, preserve, and report critical digital evidence with uncompromising accuracy.
            </p>
            <div className="hero-bottom">
              <div className="hero-stats">
                <div className="stat">
                  <div className="stat-number">Precision</div>
                  <div className="stat-label">Comprehensive Report</div>
                </div>
                <div className="stat">
                  <div className="stat-number">Responsive</div>
                  <div className="stat-label">Immediate Response</div>
                </div>
                <div className="stat">
                  <div className="stat-number">Protection</div>
                  <div className="stat-label">Industrial Encryption Standard</div>
                </div>
              </div>
              <a href="#contact" className="hero-cta">Contact Us</a>
            </div>
          </div>
          <div className="hero-image">
            <img className="hero-transfer-img" src={transferImg} alt="Data Transfer Illustration" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroComp;




